import cx from "classnames";
import { forwardRef, type ReactNode } from "react";

export type ButtonProps = {
  children: ReactNode;
  large?: boolean;
  small?: boolean;
  phantom?: boolean;
  dark?: boolean;
  link?: boolean;
  disabled?: boolean;
  type?: "submit" | "button";
  style?: React.HTMLAttributes<HTMLButtonElement>["style"];
  className?: string;
  onClick?: () => void;
  endAdornment?: JSX.Element;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      type = "button",
      children,
      small,
      large,
      phantom,
      dark,
      disabled = false,
      link,
      endAdornment,
      className: classNameProp,
      ...props
    },
    buttonRef
  ) => {
    const className = cx(
      "Button",
      classNameProp,
      {
        "Button--dark": dark,
        "Button--phantom": phantom,
        "Button--small": small,
        "Button--large": large,
      }
    );
    return link ? (
      <span className={className}>
        <span className="ButtonText">{children}</span>
      </span>
    ) : (
      <button
        ref={buttonRef}
        type={type}
        disabled={disabled}
        {...props}
        className={className}
      >
        <span className="ButtonText">{children}</span>
        {endAdornment}
      </button>
    );
  }
);

Button.displayName = "Button";
export default Button;
